// WebsiteDevelopment.jsx
import React, { useContext, useEffect } from 'react';
import img from '../../../assets/Img';
import { LocalizationContext } from '../../../context/LangChange';
import '../seo.css';
import '../Service/scervice.scss';
import ServicesSlider from './../ServicesSlider';
import WhoWeAre from './WhoWeAre';
import WebsiteServiceHome from './WebsiteServiceHome';
import CustomCMS from './CustomCMS';
import ToolsWeb from './ToolsWeb';
import Languages from './Languages';
import Component from '../../../constants/Component';

const translations = {
  en: require('../../../Translate/en.json').WebsiteDevelopment,
  ar: require('../../../Translate/ar.json').WebsiteDevelopment,
};

const WebsiteDevelopment = () => {
  const { isLang } = useContext(LocalizationContext);
  const t = translations[isLang || 'en'];

  const data = {
    title: t.title,
    dec: t.dec,
    title2: t.title2,
    dec2: t.dec2,
    img: img.WebsiteDevelopmentSlider,
  };
 useEffect(() => { 
    window.scroll(0, 0)  
  }, [])

  return (
    <div className="app_website_development overflow-hidden">
      <div className="slider">
        <ServicesSlider data={data} />
      </div>
      <WhoWeAre />
      <WebsiteServiceHome />
      <CustomCMS />
      <ToolsWeb />
      <Languages/>
      <Component.ContactUSHome />
    </div>
  );
};

export default WebsiteDevelopment;
